const LeftArrow = () => {
  return (
    <svg
      width="44"
      height="64"
      viewBox="0 0 44 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M43.2949 63.1781L0.425046 32L43.2949 0.8219L27.2778 31.8854L27.2187 32L27.2778 32.1146L43.2949 63.1781Z"
        fill="#00FFF0"
        stroke="#00FFF0"
        strokeWidth="0.5"
      />
    </svg>
  )
}

export default LeftArrow
